import api from './client';

export const loginWithCode = async (code: string): Promise<string> => {
  const response = await api.post('/users/login', { code });
  return response.data.token as string;
};

export const getGoogleCode = async () => {
  var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

  // Create <form> element to submit parameters to OAuth 2.0 endpoint.
  var form = document.createElement('form');
  form.setAttribute('method', 'GET'); // Send as a GET request.
  form.setAttribute('action', oauth2Endpoint);

  // Parameters to pass to OAuth 2.0 endpoint.
  var params = {
    client_id:
      '854566616747-7jurhs56p5abhrfdro8eflm425jbf79s.apps.googleusercontent.com',
    redirect_uri: process.env.REACT_APP_REDIRECT_URL || 'http://localhost:3000',
    response_type: 'code',
    scope: 'openid profile email',
    include_granted_scopes: 'true',
    state: 'pass-through value',
    project_id: 'cognitedata-development',
  };
  for (var p in params) {
    var input = document.createElement('input');
    const x =
      params[
        p as
          | 'client_id'
          | 'state'
          | 'redirect_uri'
          | 'response_type'
          | 'scope'
          | 'include_granted_scopes'
          | 'project_id'
      ];
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', p);
    input.setAttribute('value', x);
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
};

export const getUser = async () => {
  const response = await api.get('/users/me');
  return response.data;
};
